export { useWallet as useTronWallet } from '@tronweb3/tronwallet-adapter-react-hooks';
import { TronLinkAdapter } from '@tronweb3/tronwallet-adapter-tronlink';
import { jsxs, jsx } from 'react/jsx-runtime';

let tronGlobalData = {};
const setTronGlobalData = (value) => {
  tronGlobalData = {
    ...tronGlobalData,
    ...value
  };
};

function defaultTronConfig(params) {
  const {
    autoConnect = false,
    initialChainId,
    // metadata = { name: 'WalletKit' },
    // walletConnectProjectId,
    // rpcUrl,
    wallets
  } = params;
  setTronGlobalData({
    // metadata,
    // walletConnectProjectId,
    // walletConnectModalIsOpen: false,
    // rpcUrl,
  });
  const adapters = wallets.map((w) => w.getAdapter());
  return {
    autoConnect,
    initialChainId,
    // metadata,
    // walletConnectProjectId,
    adapters,
    // rpcUrl,
    wallets
  };
}

const TronLinkTransparentIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", { width: "40", height: "40", viewBox: "0 0 65 65", fill: "none", ...props, children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_18_3)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.30721 0C3.27132 0 0 3.59886 0 8.03839V56.9616C0 61.4011 3.27132 65 7.30721 65H57.6928C61.7283 65 65 61.4011 65 56.9616V8.03839C65 3.59886 61.7283 0 57.6928 0H7.30721Z",
          fill: "url(#paint0_linear_18_3)"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "mask0_18_3", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "65", height: "65", children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.30721 0C3.27132 0 0 3.59886 0 8.03839V56.9616C0 61.4011 3.27132 65 7.30721 65H57.6928C61.7283 65 65 61.4011 65 56.9616V8.03839C65 3.59886 61.7283 0 57.6928 0H7.30721Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { mask: "url(#mask0_18_3)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M55.146 50.8465L85.3058 45.3974L50.7112 87.4441L55.146 50.8465ZM50.8147 48.7967L46.1368 87.4028L20.893 24.0406L50.8147 48.7967ZM52.8592 44.5958L24.1489 20.8417L71.0713 29.4557L52.8592 44.5958ZM76.0546 31.217L86.012 40.661L58.775 45.5816L76.0546 31.217ZM77.101 25.9507L12 14L46.263 100L94 41.9787L77.101 25.9507Z",
          fill: "white"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_18_3",
          x1: "537.383",
          y1: "266.088",
          x2: "6244.77",
          y2: "6544.28",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#145ECC" }),
            /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#1260CC" })
          ]
        }
      ),
      /* @__PURE__ */ jsx("clipPath", { id: "clip0_18_3", children: /* @__PURE__ */ jsx("rect", { width: "65", height: "65", fill: "white" }) })
    ] })
  ] });
};
const TronLinkIcon = (props) => {
  return /* @__PURE__ */ jsx(TronLinkTransparentIcon, { ...props });
};

const tronLinkConfig = {
  name: "TronLink",
  logos: {
    default: /* @__PURE__ */ jsx(TronLinkIcon, {}),
    transparent: /* @__PURE__ */ jsx(TronLinkTransparentIcon, {})
  },
  downloadUrls: {
    default: "https://www.tronlink.org/"
  },
  spinnerColor: "#2980FE"
};

function getTronInjectedProvider(flag) {
  if (typeof window === "undefined" || typeof window.tron === "undefined")
    return;
  return window.tron[flag] ? window.tron : void 0;
}
function hasTronInjectedProvider(flag) {
  return Boolean(getTronInjectedProvider(flag));
}

function tronLink(props = {}) {
  const { adapterOptions, ...restProps } = props;
  return {
    ...tronLinkConfig,
    id: "tron:tronLink",
    walletType: "tron",
    adapterName: "TronLink",
    showQRCode: false,
    isInstalled() {
      if (typeof window === "undefined")
        return false;
      return hasTronInjectedProvider("isTronLink");
    },
    getAdapter() {
      return new TronLinkAdapter({
        ...adapterOptions
      });
    },
    ...restProps
  };
}

export { defaultTronConfig, tronLink };
